
"use strict";

// =====================================================
// REPORTES PÓLIZA CONTABLE
//
// Archivo:
// src/fronend/reportes/poliza/poliza.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosreportespoliza = [];


// =====================================================
// ELEMENTOS DEL DOM
// =====================================================

const tbodyreportespoliza =
    document.getElementById("tbodyreportespoliza");

const buscarPoliza =
    document.getElementById("buscarPoliza");

const btnLimpiarBusquedaPoliza =
    document.getElementById("btnLimpiarBusquedaPoliza");

const totalEmpleadosPoliza =
    document.getElementById("totalEmpleadosPoliza");

const totalNetoPoliza =
    document.getElementById("totalNetoPoliza");

const btnPDFPoliza =
    document.getElementById("btnPDFPoliza");


// =====================================================
// CARGAR REPORTE PÓLIZA
// =====================================================

const cargarReportePoliza = async () => {

    try {

        const respuesta =
            await fetch("/poliza/listar");


        if (!respuesta.ok) {

            throw new Error(
                "No se pudo obtener el reporte de Póliza Contable."
            );

        }


        registrosreportespoliza =
            await respuesta.json();


        console.log(
            "Reporte Póliza:",
            registrosreportespoliza
        );


        mostrarPoliza(
            registrosreportespoliza
        );


        actualizarResumenPoliza(
            registrosreportespoliza
        );


    }
    catch (error) {

        console.error(
            "Error al cargar el reporte de Póliza:",
            error
        );


        if (tbodyreportespoliza) {

            tbodyreportespoliza.innerHTML = `

                <tr>

                    <td
                        colspan="19"
                        class="error-state">

                        <i class="bi bi-exclamation-triangle-fill"></i>

                        <div class="fw-bold mb-1">

                            Error al cargar el reporte

                        </div>

                        <div>

                            No se pudo obtener
                            la Póliza Contable.

                        </div>

                    </td>

                </tr>

            `;

        }


        if (totalEmpleadosPoliza) {

            totalEmpleadosPoliza.textContent =
                "0";

        }


        if (totalNetoPoliza) {

            totalNetoPoliza.textContent =
                "Q 0.00";

        }

    }

};


// =====================================================
// MOSTRAR PÓLIZA
// =====================================================

const mostrarPoliza = (registros) => {

    if (!tbodyreportespoliza) {

        return;

    }


    tbodyreportespoliza.innerHTML = "";


    // =================================================
    // SIN REGISTROS
    // =================================================

    if (
        !registros ||
        registros.length === 0
    ) {

        tbodyreportespoliza.innerHTML = `

            <tr>

                <td
                    colspan="19"
                    class="empty-state">

                    <i class="bi bi-journal-x"></i>

                    <div class="fw-bold mb-1">

                        No hay registros disponibles

                    </div>

                    <div>

                        No se encontraron datos
                        en la Póliza Contable.

                    </div>

                </td>

            </tr>

        `;

        return;

    }


    // =================================================
    // AGRUPAR POR CUENTA Y DEPARTAMENTO
    // =================================================

    const grupos = {};


    registros.forEach(
        (registro) => {

            const cuenta =
                registro["CUENTA CONTABLE"] ?? "";


            const departamento =
                registro.NOMBRETECNOLOGICO ?? "";


            const clave =
                `${cuenta}|${departamento}`;


            if (!grupos[clave]) {

                grupos[clave] = {

                    cuenta:
                        cuenta,

                    departamento:
                        departamento,

                    registros: []

                };

            }


            grupos[clave]
                .registros
                .push(
                    registro
                );

        }
    );


    // =================================================
    // MOSTRAR GRUPOS
    // =================================================

    let contador = 1;


    Object.values(grupos).forEach(
        (grupo) => {


            // =========================================
            // ENCABEZADO DEL GRUPO
            // =========================================

            const filaGrupo =
                document.createElement("tr");


            filaGrupo.className =
                "table-success fw-bold";


            filaGrupo.innerHTML = `

                <td colspan="19">

                    CUENTA:

                    ${grupo.cuenta}

                    |

                    DEPARTAMENTO:

                    ${grupo.departamento}

                </td>

            `;


            tbodyreportespoliza.appendChild(
                filaGrupo
            );


            // =========================================
            // SUBTOTAL
            // =========================================

            let subtotalNeto = 0;


            // =========================================
            // EMPLEADOS
            // =========================================

            grupo.registros.forEach(
                (registro) => {

                    const sueldoBase =
                        Number(
                            registro["SALARIO BASE"] ??
                            registro["SUELDO BASE"]
                        ) || 0;


                    const horasExtras =
                        Number(
                            registro["PAGO POR HORAS EXTRAS"]
                        ) || 0;


                    const horasDobles =
                        Number(
                            registro[
                                "PAGO POR HORAS DOBLES AL MES"
                            ]
                        ) || 0;


                    const produccionBonificacion =
                        Number(
                            registro[
                                "PAGOS POR PRODUCCION BONIFICACION"
                            ]
                        ) || 0;


                    const comisiones =
                        Number(
                            registro[
                                "PAGO POR COMISIONES EMPLEADOS"
                            ]
                        ) || 0;


                    const anticipo =
                        Number(
                            registro[
                                "PAGO POR ANTICIPADO"
                            ]
                        ) || 0;


                    const igss =
                        Number(
                            registro[
                                "DESCUENTO IGSS APLICADO"
                            ]
                        ) || 0;


                    const isr =
                        Number(
                            registro[
                                "PAGO POR ISR APLICADO"
                            ]
                        ) || 0;


                    const descuentoBanco =
                        Number(
                            registro[
                                "DESCUENTO APLICADO POR AHORRO DE BANCO TOTAL"
                            ]
                        ) || 0;


                    const descuentoTienda =
                        Number(
                            registro[
                                "DESCUENTO POR TIENDA PAGO"
                            ]
                        ) || 0;


                    const totalIngresado =
                        Number(
                            registro[
                                "TOTAL INGRESADO"
                            ]
                        ) || 0;


                    const totalEgresos =
                        Number(
                            registro[
                                "TOTAL DE EGRESOS"
                            ]
                        ) || 0;


                    const sueldoNuevo =
                        Number(
                            registro.SUELDONUEVO
                        ) || 0;


                    subtotalNeto +=
                        sueldoNuevo;


                    const fila =
                        document.createElement("tr");


                    fila.innerHTML = `

                        <td class="numero text-center">

                            ${contador}

                        </td>


                        <td>

                            ${grupo.cuenta}

                        </td>


                        <td>

                            ${grupo.departamento}

                        </td>


                        <td>

                            ${registro.NOMBREEMPLEADO ?? ""}

                        </td>


                        <td>

                            ${registro.NOMBREPUESTO ?? ""}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                sueldoBase
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                horasExtras
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                horasDobles
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                produccionBonificacion
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                comisiones
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                anticipo
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                igss
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                isr
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                descuentoBanco
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                descuentoTienda
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                totalIngresado
                            )}

                        </td>


                        <td class="text-end">

                            Q ${formatearMoneda(
                                totalEgresos
                            )}

                        </td>


                        <td class="text-end fw-bold">

                            Q ${formatearMoneda(
                                sueldoNuevo
                            )}

                        </td>

                    `;


                    tbodyreportespoliza.appendChild(
                        fila
                    );


                    contador++;

                }
            );


            // =========================================
            // SUBTOTAL
            // =========================================

            const filaSubtotal =
                document.createElement("tr");


            filaSubtotal.className =
                "fw-bold table-light";


            filaSubtotal.innerHTML = `

                <td
                    colspan="17"
                    class="text-end"
                >

                    SUBTOTAL
                    ${grupo.departamento}:

                </td>


                <td class="text-end">

                    Q ${formatearMoneda(
                        subtotalNeto
                    )}

                </td>

            `;


            tbodyreportespoliza.appendChild(
                filaSubtotal
            );

        }
    );

};


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

const actualizarResumenPoliza = (
    registros
) => {

    if (!registros) {

        return;

    }


    // =================================================
    // TOTAL EMPLEADOS
    // =================================================

    if (totalEmpleadosPoliza) {

        totalEmpleadosPoliza.textContent =
            registros.length;

    }


    // =================================================
    // TOTAL SUELDO NUEVO
    // =================================================

    let totalNeto = 0;


    registros.forEach(
        (registro) => {

            totalNeto +=
                Number(
                    registro.SUELDONUEVO
                ) || 0;

        }
    );


    // =================================================
    // MOSTRAR TOTAL NETO
    // =================================================

    if (totalNetoPoliza) {

        totalNetoPoliza.textContent =
            `Q ${formatearMoneda(
                totalNeto
            )}`;

    }

};


// =====================================================
// FORMATEAR MONEDA
// =====================================================

const formatearMoneda = (
    valor
) => {

    const numero =
        Number(valor) || 0;


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

};


// =====================================================
// BUSCAR EN EL REPORTE
// =====================================================

const filtrarPoliza = () => {

    const texto =
        buscarPoliza
            ? buscarPoliza.value
                .trim()
                .toLowerCase()
            : "";


    // =================================================
    // SIN TEXTO
    // =================================================

    if (!texto) {

        mostrarPoliza(
            registrosreportespoliza
        );


        actualizarResumenPoliza(
            registrosreportespoliza
        );


        return;

    }


    // =================================================
    // FILTRAR
    // =================================================

    const registrosFiltrados =
        registrosreportespoliza.filter(
            (registro) => {

                const departamento =
                    String(
                        registro.NOMBRETECNOLOGICO ?? ""
                    )
                    .toLowerCase();


                const empleado =
                    String(
                        registro.NOMBREEMPLEADO ?? ""
                    )
                    .toLowerCase();


                const puesto =
                    String(
                        registro.NOMBREPUESTO ?? ""
                    )
                    .toLowerCase();


                const cuenta =
                    String(
                        registro["CUENTA CONTABLE"] ?? ""
                    )
                    .toLowerCase();


                const banco =
                    String(
                        registro.NOMBREBANCO ?? ""
                    )
                    .toLowerCase();


                const idEmpleado =
                    String(
                        registro.IDEMPLEADO ?? ""
                    )
                    .toLowerCase();


                return (

                    departamento.includes(
                        texto
                    ) ||

                    empleado.includes(
                        texto
                    ) ||

                    puesto.includes(
                        texto
                    ) ||

                    cuenta.includes(
                        texto
                    ) ||

                    banco.includes(
                        texto
                    ) ||

                    idEmpleado.includes(
                        texto
                    )

                );

            }
        );


    // =================================================
    // MOSTRAR FILTRADOS
    // =================================================

    mostrarPoliza(
        registrosFiltrados
    );


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    actualizarResumenPoliza(
        registrosFiltrados
    );

};


// =====================================================
// EVENTO BUSCAR
// =====================================================

if (buscarPoliza) {

    buscarPoliza.addEventListener(
        "input",
        filtrarPoliza
    );

}


// =====================================================
// LIMPIAR BÚSQUEDA
// =====================================================

if (btnLimpiarBusquedaPoliza) {

    btnLimpiarBusquedaPoliza.addEventListener(
        "click",
        () => {

            if (buscarPoliza) {

                buscarPoliza.value = "";

            }


            mostrarPoliza(
                registrosreportespoliza
            );


            actualizarResumenPoliza(
                registrosreportespoliza
            );

        }
    );

}


// =====================================================
// CARGAR LIBRERÍA jsPDF
// =====================================================

const cargarJsPDF = () => {

    return new Promise(
        (resolve, reject) => {

            if (
                window.jspdf &&
                window.jspdf.jsPDF
            ) {

                resolve();

                return;

            }


            const script =
                document.createElement(
                    "script"
                );


            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";


            script.onload = () => {

                resolve();

            };


            script.onerror = () => {

                reject(
                    new Error(
                        "No se pudo cargar jsPDF."
                    )
                );

            };


            document.head.appendChild(
                script
            );

        }
    );

};


// =====================================================
// CARGAR jsPDF-AUTO-TABLE
// =====================================================

const cargarAutoTable = () => {

    return new Promise(
        (resolve, reject) => {

            if (
                window.jspdf &&
                window.jspdf.jsPDF &&
                window.jspdf.jsPDF.API &&
                window.jspdf.jsPDF.API.autoTable
            ) {

                resolve();

                return;

            }


            const script =
                document.createElement(
                    "script"
                );


            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js";


            script.onload = () => {

                resolve();

            };


            script.onerror = () => {

                reject(
                    new Error(
                        "No se pudo cargar jsPDF-AutoTable."
                    )
                );

            };


            document.head.appendChild(
                script
            );

        }
    );

};


// =====================================================
// GENERAR PDF
// =====================================================

const generarPDFPoliza = async () => {

    try {

        // =============================================
        // VALIDAR REGISTROS
        // =============================================

        if (
            !registrosreportespoliza ||
            registrosreportespoliza.length === 0
        ) {

            alert(
                "No hay datos para generar el PDF."
            );

            return;

        }


        // =============================================
        // CAMBIAR ESTADO DEL BOTÓN
        // =============================================

        const textoOriginal =
            btnPDFPoliza
                ? btnPDFPoliza.innerHTML
                : "";


        if (btnPDFPoliza) {

            btnPDFPoliza.disabled =
                true;


            btnPDFPoliza.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm me-2">
                </span>

                Generando PDF...

            `;

        }


        // =============================================
        // CARGAR LIBRERÍAS
        // =============================================

        await cargarJsPDF();

        await cargarAutoTable();


        // =============================================
        // CREAR DOCUMENTO
        // =============================================

        const {
            jsPDF
        } = window.jspdf;


        const doc =
            new jsPDF({

                orientation:
                    "landscape",

                unit:
                    "mm",

                format:
                    "legal"

            });


        // =============================================
        // TOMAR DATOS FILTRADOS ACTUALES
        // =============================================

        const textoBusqueda =
            buscarPoliza
                ? buscarPoliza.value
                    .trim()
                    .toLowerCase()
                : "";


        let registrosPDF =
            registrosreportespoliza;


        if (textoBusqueda) {

            registrosPDF =
                registrosreportespoliza.filter(
                    (registro) => {

                        const departamento =
                            String(
                                registro.NOMBRETECNOLOGICO ?? ""
                            )
                            .toLowerCase();


                        const empleado =
                            String(
                                registro.NOMBREEMPLEADO ?? ""
                            )
                            .toLowerCase();


                        const puesto =
                            String(
                                registro.NOMBREPUESTO ?? ""
                            )
                            .toLowerCase();


                        const cuenta =
                            String(
                                registro["CUENTA CONTABLE"] ?? ""
                            )
                            .toLowerCase();


                        const banco =
                            String(
                                registro.NOMBREBANCO ?? ""
                            )
                            .toLowerCase();


                        const idEmpleado =
                            String(
                                registro.IDEMPLEADO ?? ""
                            )
                            .toLowerCase();


                        return (

                            departamento.includes(
                                textoBusqueda
                            ) ||

                            empleado.includes(
                                textoBusqueda
                            ) ||

                            puesto.includes(
                                textoBusqueda
                            ) ||

                            cuenta.includes(
                                textoBusqueda
                            ) ||

                            banco.includes(
                                textoBusqueda
                            ) ||

                            idEmpleado.includes(
                                textoBusqueda
                            )

                        );

                    }
                );

        }


        // =============================================
        // VALIDAR FILTRADOS
        // =============================================

        if (
            !registrosPDF ||
            registrosPDF.length === 0
        ) {

            alert(
                "No hay datos que coincidan con la búsqueda."
            );


            if (btnPDFPoliza) {

                btnPDFPoliza.disabled =
                    false;

                btnPDFPoliza.innerHTML =
                    textoOriginal;

            }

            return;

        }


        // =============================================
        // AGRUPAR REGISTROS
        // =============================================

        const gruposPDF = {};


        registrosPDF.forEach(
            (registro) => {

                const cuenta =
                    registro["CUENTA CONTABLE"] ?? "";


                const departamento =
                    registro.NOMBRETECNOLOGICO ?? "";


                const clave =
                    `${cuenta}|${departamento}`;


                if (!gruposPDF[clave]) {

                    gruposPDF[clave] = {

                        cuenta:
                            cuenta,

                        departamento:
                            departamento,

                        registros: []

                    };

                }


                gruposPDF[clave]
                    .registros
                    .push(
                        registro
                    );

            }
        );


        // =============================================
        // FECHA
        // =============================================

        const fecha =
            new Date().toLocaleDateString(
                "es-GT"
            );


        // =============================================
        // TOTALES GENERALES
        // =============================================

        let totalSueldoBase =
            0;

        let totalHorasExtras =
            0;

        let totalHorasDobles =
            0;

        let totalProduccionBonificacion =
            0;

        let totalComisiones =
            0;

        let totalAnticipo =
            0;

        let totalIGSS =
            0;

        let totalISR =
            0;

        let totalBanco =
            0;

        let totalTienda =
            0;

        let totalIngresado =
            0;

        let totalEgresos =
            0;

        let totalSueldoNuevo =
            0;


        registrosPDF.forEach(
            (registro) => {

                totalSueldoBase +=
                    Number(
                        registro["SALARIO BASE"] ??
                        registro["SUELDO BASE"]
                    ) || 0;


                totalHorasExtras +=
                    Number(
                        registro[
                            "PAGO POR HORAS EXTRAS"
                        ]
                    ) || 0;


                totalHorasDobles +=
                    Number(
                        registro[
                            "PAGO POR HORAS DOBLES AL MES"
                        ]
                    ) || 0;


                totalProduccionBonificacion +=
                    Number(
                        registro[
                            "PAGOS POR PRODUCCION BONIFICACION"
                        ]
                    ) || 0;


                totalComisiones +=
                    Number(
                        registro[
                            "PAGO POR COMISIONES EMPLEADOS"
                        ]
                    ) || 0;


                totalAnticipo +=
                    Number(
                        registro[
                            "PAGO POR ANTICIPADO"
                        ]
                    ) || 0;


                totalIGSS +=
                    Number(
                        registro[
                            "DESCUENTO IGSS APLICADO"
                        ]
                    ) || 0;


                totalISR +=
                    Number(
                        registro[
                            "PAGO POR ISR APLICADO"
                        ]
                    ) || 0;


                totalBanco +=
                    Number(
                        registro[
                            "DESCUENTO APLICADO POR AHORRO DE BANCO TOTAL"
                        ]
                    ) || 0;


                totalTienda +=
                    Number(
                        registro[
                            "DESCUENTO POR TIENDA PAGO"
                        ]
                    ) || 0;


                totalIngresado +=
                    Number(
                        registro[
                            "TOTAL INGRESADO"
                        ]
                    ) || 0;


                totalEgresos +=
                    Number(
                        registro[
                            "TOTAL DE EGRESOS"
                        ]
                    ) || 0;


                totalSueldoNuevo +=
                    Number(
                        registro.SUELDONUEVO
                    ) || 0;

            }
        );


        // =============================================
        // ENCABEZADO
        // =============================================

        doc.setFont(
            "helvetica",
            "bold"
        );


        doc.setFontSize(
            18
        );


        doc.text(
            "CONSULTING S.A.",
            12,
            14
        );


        doc.setFontSize(
            14
        );


        doc.text(
            "PÓLIZA CONTABLE DE NÓMINA",
            12,
            21
        );


        doc.setFont(
            "helvetica",
            "normal"
        );


        doc.setFontSize(
            8
        );


        doc.text(
            "Póliza contable de nómina por departamento y cuenta contable.",
            12,
            27
        );


        doc.text(
            `Fecha de generación: ${fecha}`,
            12,
            33
        );


        // =============================================
        // RESUMEN
        // =============================================

        doc.setFont(
            "helvetica",
            "bold"
        );


        doc.setFontSize(
            8
        );


        doc.text(
            `Empleados: ${registrosPDF.length}`,
            210,
            14
        );


        doc.text(
            `Sueldo Base: Q ${formatearMoneda(
                totalSueldoBase
            )}`,
            210,
            20
        );


        doc.text(
            `Total Ingresado: Q ${formatearMoneda(
                totalIngresado
            )}`,
            210,
            26
        );


        doc.text(
            `Total Egresos: Q ${formatearMoneda(
                totalEgresos
            )}`,
            210,
            32
        );


        doc.text(
            `Sueldo Nuevo: Q ${formatearMoneda(
                totalSueldoNuevo
            )}`,
            210,
            38
        );


        // =============================================
        // DATOS DE LA TABLA
        // =============================================

        const datosTabla = [];


        let contador =
            1;


        Object.values(gruposPDF).forEach(
            (grupo) => {

                // =====================================
                // FILA CUENTA / DEPARTAMENTO
                // =====================================

                datosTabla.push([

                    {

                        content:
                            `CUENTA: ${grupo.cuenta} | DEPARTAMENTO: ${grupo.departamento}`,

                        colSpan:
                            19,

                        styles: {

                            fontStyle:
                                "bold",

                            halign:
                                "left"

                        }

                    }

                ]);


                // =====================================
                // EMPLEADOS
                // =====================================

                let subtotalSueldoNuevo =
                    0;


                grupo.registros.forEach(
                    (registro) => {

                        const sueldoBase =
                            Number(
                                registro[
                                    "SALARIO BASE"
                                ] ??
                                registro[
                                    "SUELDO BASE"
                                ]
                            ) || 0;


                        const horasExtras =
                            Number(
                                registro[
                                    "PAGO POR HORAS EXTRAS"
                                ]
                            ) || 0;


                        const horasDobles =
                            Number(
                                registro[
                                    "PAGO POR HORAS DOBLES AL MES"
                                ]
                            ) || 0;


                        const produccionBonificacion =
                            Number(
                                registro[
                                    "PAGOS POR PRODUCCION BONIFICACION"
                                ]
                            ) || 0;


                        const comisiones =
                            Number(
                                registro[
                                    "PAGO POR COMISIONES EMPLEADOS"
                                ]
                            ) || 0;


                        const anticipo =
                            Number(
                                registro[
                                    "PAGO POR ANTICIPADO"
                                ]
                            ) || 0;


                        const igss =
                            Number(
                                registro[
                                    "DESCUENTO IGSS APLICADO"
                                ]
                            ) || 0;


                        const isr =
                            Number(
                                registro[
                                    "PAGO POR ISR APLICADO"
                                ]
                            ) || 0;


                        const banco =
                            Number(
                                registro[
                                    "DESCUENTO APLICADO POR AHORRO DE BANCO TOTAL"
                                ]
                            ) || 0;


                        const tienda =
                            Number(
                                registro[
                                    "DESCUENTO POR TIENDA PAGO"
                                ]
                            ) || 0;


                        const totalIngresadoRegistro =
                            Number(
                                registro[
                                    "TOTAL INGRESADO"
                                ]
                            ) || 0;


                        const totalEgresosRegistro =
                            Number(
                                registro[
                                    "TOTAL DE EGRESOS"
                                ]
                            ) || 0;


                        const sueldoNuevo =
                            Number(
                                registro.SUELDONUEVO
                            ) || 0;


                        subtotalSueldoNuevo +=
                            sueldoNuevo;


                        datosTabla.push([

                            contador,

                            grupo.cuenta,

                            grupo.departamento,

                            registro.NOMBREEMPLEADO ?? "",

                            registro.NOMBREPUESTO ?? "",

                            `Q ${formatearMoneda(
                                sueldoBase
                            )}`,

                            `Q ${formatearMoneda(
                                horasExtras
                            )}`,

                            `Q ${formatearMoneda(
                                horasDobles
                            )}`,

                            `Q ${formatearMoneda(
                                produccionBonificacion
                            )}`,

                            `Q ${formatearMoneda(
                                comisiones
                            )}`,

                            `Q ${formatearMoneda(
                                anticipo
                            )}`,

                            `Q ${formatearMoneda(
                                igss
                            )}`,

                            `Q ${formatearMoneda(
                                isr
                            )}`,

                            `Q ${formatearMoneda(
                                banco
                            )}`,

                            `Q ${formatearMoneda(
                                tienda
                            )}`,

                            `Q ${formatearMoneda(
                                totalIngresadoRegistro
                            )}`,

                            `Q ${formatearMoneda(
                                totalEgresosRegistro
                            )}`,

                            `Q ${formatearMoneda(
                                sueldoNuevo
                            )}`

                        ]);


                        contador++;

                    }
                );


                // =====================================
                // SUBTOTAL
                // =====================================

                datosTabla.push([

                    {

                        content:
                            `SUBTOTAL ${grupo.departamento}:`,

                        colSpan:
                            17,

                        styles: {

                            fontStyle:
                                "bold",

                            halign:
                                "right"

                        }

                    },

                    {

                        content:
                            `Q ${formatearMoneda(
                                subtotalSueldoNuevo
                            )}`,

                        styles: {

                            fontStyle:
                                "bold",

                            halign:
                                "right"

                        }

                    }

                ]);

            }
        );


        // =============================================
        // TOTAL GENERAL
        // =============================================

        datosTabla.push([

            {

                content:
                    "TOTAL GENERAL:",

                colSpan:
                    17,

                styles: {

                    fontStyle:
                        "bold",

                    halign:
                        "right"

                }

            },

            {

                content:
                    `Q ${formatearMoneda(
                        totalSueldoNuevo
                    )}`,

                styles: {

                    fontStyle:
                        "bold",

                    halign:
                        "right"

                }

            }

        ]);


        // =============================================
        // CREAR TABLA PDF
        // =============================================

        doc.autoTable({

            startY:
                43,


            head: [[

                "#",

                "Cuenta",

                "Departamento",

                "Empleado",

                "Puesto",

                "Sueldo Base",

                "H. Extras",

                "H. Dobles",

                "Bonificación",

                "Comisiones",

                "Anticipo",

                "IGSS",

                "ISR",

                "Banco",

                "Tienda",

                "Total Ingresado",

                "Total Egresos",

                "Sueldo Nuevo"

            ]],


            body:
                datosTabla,


            theme:
                "grid",


            styles: {

                font:
                    "helvetica",

                fontSize:
                    5.5,

                cellPadding:
                    1.2,

                valign:
                    "middle",

                lineWidth:
                    0.1

            },


            headStyles: {

                fontStyle:
                    "bold",

                halign:
                    "center",

                fontSize:
                    6

            },


            columnStyles: {

                0: {

                    halign:
                        "center",

                    cellWidth:
                        7

                },

                1: {

                    cellWidth:
                        13

                },

                2: {

                    cellWidth:
                        20

                },

                3: {

                    cellWidth:
                        28

                },

                4: {

                    cellWidth:
                        20

                },

                5: {

                    halign:
                        "right",

                    cellWidth:
                        18

                },

                6: {

                    halign:
                        "right",

                    cellWidth:
                        17

                },

                7: {

                    halign:
                        "right",

                    cellWidth:
                        17

                },

                8: {

                    halign:
                        "right",

                    cellWidth:
                        19

                },

                9: {

                    halign:
                        "right",

                    cellWidth:
                        18

                },

                10: {

                    halign:
                        "right",

                    cellWidth:
                        17

                },

                11: {

                    halign:
                        "right",

                    cellWidth:
                        16

                },

                12: {

                    halign:
                        "right",

                    cellWidth:
                        16

                },

                13: {

                    halign:
                        "right",

                    cellWidth:
                        18

                },

                14: {

                    halign:
                        "right",

                    cellWidth:
                        18

                },

                15: {

                    halign:
                        "right",

                    cellWidth:
                        20

                },

                16: {

                    halign:
                        "right",

                    cellWidth:
                        20

                },

                17: {

                    halign:
                        "right",

                    cellWidth:
                        20

                }

            },


            margin: {

                left:
                    6,

                right:
                    6

            },


            didParseCell:
                function (data) {

                    // =================================
                    // FILA CUENTA / DEPARTAMENTO
                    // =================================

                    if (
                        data.row.raw &&
                        data.row.raw[0] &&
                        data.row.raw[0].colSpan === 19
                    ) {

                        data.cell.styles.fontStyle =
                            "bold";

                    }


                    // =================================
                    // TOTAL GENERAL
                    // =================================

                    if (
                        data.row.raw &&
                        data.row.raw[0] &&
                        data.row.raw[0].content ===
                        "TOTAL GENERAL:"
                    ) {

                        data.cell.styles.fontStyle =
                            "bold";

                    }

                },


            didDrawPage:
                function () {

                    const numeroPagina =
                        doc.internal
                            .getNumberOfPages();


                    doc.setFontSize(
                        7
                    );


                    doc.setFont(
                        "helvetica",
                        "normal"
                    );


                    doc.text(
                        `Página ${numeroPagina}`,
                        7,
                        doc.internal.pageSize.height - 6
                    );


                    doc.text(
                        "Consulting S.A. - Póliza Contable de Nómina",
                        doc.internal.pageSize.width - 75,
                        doc.internal.pageSize.height - 6
                    );

                }

        });


        // =============================================
        // NOMBRE DEL ARCHIVO
        // =============================================

        const fechaArchivo =
            new Date()
                .toISOString()
                .split("T")[0];


        const nombreArchivo =
            `Poliza_Contable_${fechaArchivo}.pdf`;


        // =============================================
        // DESCARGAR PDF
        // =============================================

        doc.save(
            nombreArchivo
        );


        // =============================================
        // RESTAURAR BOTÓN
        // =============================================

        if (btnPDFPoliza) {

            btnPDFPoliza.disabled =
                false;


            btnPDFPoliza.innerHTML =
                textoOriginal;

        }

    }
    catch (error) {

        console.error(
            "Error al generar PDF de Póliza:",
            error
        );


        alert(
            "No se pudo generar el PDF de la Póliza Contable."
        );


        if (btnPDFPoliza) {

            btnPDFPoliza.disabled =
                false;


            btnPDFPoliza.innerHTML = `

                <i
                    class="bi bi-file-earmark-pdf-fill me-2">
                </i>

                Generar PDF

            `;

        }

    }

};


// =====================================================
// EVENTO BOTÓN PDF
// =====================================================

if (btnPDFPoliza) {

    btnPDFPoliza.addEventListener(
        "click",
        generarPDFPoliza
    );

}


// =====================================================
// INICIAR
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    () => {

        cargarReportePoliza();

    }
);

